// @flow
import api from 'tim-api';
import {
  saleLogs
} from 'endPoints';

export const state: Object = {
  pagination: null,
  saleLogsManagement: []
};

export const getters = {
  pagination: (state: Object) => state.pagination,
  saleLogsManagement: (state: Object) => state.saleLogsManagement
};

export const mutations = {
  SET_PAGINATION(state: Object, pagination: Object) {
    state.pagination = pagination;
  },
  SET_SALE_LOGS_MANAGEMENT(state: Object, saleLogsManagement: Array<Object>) {
    state.saleLogsManagement = saleLogsManagement;
  }
};

export const actions = {
  fetchSaleLogsManagement({ commit }: Action, { page, filters }: Object) {
    const url = `${saleLogs}?page=${page || 1}&${filters}`;
    return api.get(url).then(({ data }) => {
      commit('SET_SALE_LOGS_MANAGEMENT', data.data.data);
      commit('SET_PAGINATION', {
        current_page: data.data.current_page,
        first_page_url: data.data.first_page_url,
        from: data.data.from,
        last_page: data.data.last_page,
        last_page_url: data.data.last_page_url,
        next_page_url: data.data.next_page_url,
        path: data.data.path,
        per_page: data.data.per_page,
        prev_page_url: data.data.prev_page_url,
        total: data.data.total
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
